// Wrap All in one Div JS Start

function wrapImageWrappers() {
const imageWrappers = document.querySelectorAll(".product-block--tab");

 if (imageWrappers.length > 0 && !document.querySelector(".product-block--tab_wrapper")) {
    const newWrapper = document.createElement("div");
    newWrapper.classList.add("product-block--tab_wrapper");
    imageWrappers[0].parentNode.insertBefore(newWrapper, imageWrappers[0]);
    imageWrappers.forEach(wrapper => {
        newWrapper.appendChild(wrapper);
    });
  }
}
document.addEventListener("DOMContentLoaded", wrapImageWrappers);
window.addEventListener("resize", wrapImageWrappers);
window.addEventListener("orientationchange", wrapImageWrappers);

// Wrap All in one Div JS End

// MATCH HEIGHT JS START

var matchHeight = function (selector) {
  var elements = document.querySelectorAll(selector);
  var maxHeight = 0;
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.height = 'auto';
    if (elements[i].offsetHeight > maxHeight) {
      maxHeight = elements[i].offsetHeight;
    }
  }
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.height = maxHeight + 'px';
  }
};

window.onload = function () {
  matchHeight('.product-grid .grid-item .grid-item__content');
};

window.onresize = function () {
  matchHeight('.product-grid .grid-item .grid-item__content');
};
matchHeight('.product-grid .grid-item .grid-item__content');


// MATCH HEIGHT JS END
